export enum SubscriptionStatus {
    ACTIVE = 'active',
    TRAIL = 'trialing',
    CANCELED = 'canceled'
}